import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProjectsTabs.css';

const TABS = ['active', 'inactive', 'no_activity', 'closed', 'internal'];

/**
 * ProjectsTabs component for switching between project activity-status groups
 * @param {Object} props - Component props
 * @param {string} props.activeTab - Currently active tab ('active' | 'inactive' | 'no_activity' | 'closed' | 'internal')
 * @param {function} props.onTabChange - Callback when tab is clicked
 * @returns {JSX.Element} ProjectsTabs component
 */
const ProjectsTabs = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="projects-tabs">
      {TABS.map((tab) => (
        <button
          key={tab}
          className={`projects-tab ${activeTab === tab ? 'active' : ''}`}
          onClick={() => onTabChange(tab)}
        >
          {t(`projects.${tab}`)}
        </button>
      ))}
    </div>
  );
};

export default ProjectsTabs;
